/**
 * 3D tilt effect on hover - cards tilt toward cursor position.
 * Auto-disables on touch devices and prefers-reduced-motion.
 */

export function initTilt(root: HTMLElement): () => void {
  if ('ontouchstart' in window) return () => {};

  const cards = root.querySelectorAll<HTMLElement>('[data-tilt]');
  const cleanups: (() => void)[] = [];

  for (const card of cards) {
    const maxTilt = Number(card.dataset.tiltMax ?? 35);

    function onMove(e: MouseEvent) {
      const rect = card.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      const rotateX = (0.5 - y) * maxTilt;
      const rotateY = (x - 0.5) * maxTilt;
      card.style.transform = `perspective(800px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.05, 1.05, 1.05)`;
      card.style.transformStyle = 'preserve-3d';
    }

    function onLeave() {
      card.style.transform = 'perspective(600px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
    }

    function onRipple(e: MouseEvent) {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const ripple = document.createElement('span');
      ripple.className = 'tilt-ripple';
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;
      card.appendChild(ripple);
      setTimeout(() => ripple.remove(), 600);
    }

    card.addEventListener('mousemove', onMove);
    card.addEventListener('mouseleave', onLeave);
    card.addEventListener('click', onRipple);

    cleanups.push(() => {
      card.removeEventListener('mousemove', onMove);
      card.removeEventListener('mouseleave', onLeave);
      card.removeEventListener('click', onRipple);
      card.style.transform = '';
    });
  }

  return () => cleanups.forEach((fn) => fn());
}
